// Core lib dependencies.
import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

// Shared utils for Display Items.
import * as utils from '../utils.jsx';

// Model objects.
import DisplayItem from '../../../model/entity/DisplayItem/DisplayItem.js';
import itemFactory from '../../../../apps/UgcWall/components/ItemFactory';

import { ItemProfile, ItemNetworkIcon, ItemContent } from './item-components';

class ContentCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const profile = _.get(this.props.item, 'profile');
    const { username, handle, avatar } = profile;
    const network = _.get(this.props.item, 'meta.network');
    const tags = _.get(this.props.item, 'meta.tags');
    const timestamp = utils.getItemTimestamp({
      item:                this.props.item,
      onExternalLinkClick: this.props.onExternalLinkClick,
    });

    const wrapperClassName = utils.getClassNamesForItem({
      item:         this.props.item,
      templateOpts: this.props.templateOpts,
      itemOpts:     this.props.itemOpts,
      isOverlay:    this.props.isOverlay,
      tabIndex:     this.props.tabIndex,
    });
    return (
      <div
        className={wrapperClassName}
        data-ngx-tags={tags}
        data-ngx-id={this.props.item.id}
        tabIndex={this.props.tabIndex}
        onClick={() => this.props.onClick(this.props.item)}
      >
        <div className="xItemInner">
          <If condition={!!username || !!handle || !!avatar}>
            <ItemProfile
              username={username}
              handle={handle}
              avatar={avatar}
              network={_.get(this.props.item.meta, 'network')}
              onExternalLinkClick={this.props.onExternalLinkClick}
            />
          </If>
          <ItemContent
            type="main"
            heading={this.props.item.content.heading}
            byline={this.props.item.content.byline}
            description={this.props.item.content.description}
            content={this.props.item.content.content}
            caption={this.props.item.content.caption}
            network={network}
            displayedUrls={this.props.item.content.displayedUrls}
            onExternalLinkClick={this.props.onExternalLinkClick}
            tags={tags}
          />
          <ItemContent type="secondary" caption={this.props.item.content.caption} />
          <If condition={!_.isEmpty(this.props.item.originalContent)}>
            <div className="xOriginalContainer">
              {itemFactory({
                item:                this.props.item.originalContent,
                itemOpts:            this.props.itemOpts,
                templateOpts:        this.props.templateOpts,
                moduleOpts:          this.props.moduleOpts,
                assetUrl:            this.props.assetUrl,
                assetUgcUrl:         this.props.assetUgcUrl,
                onExternalLinkClick: this.props.onExternalLinkClick,
                onClick:             _.noop,
                tabIndex:            -1, // disable quoted container from gaining focus
              })}
            </div>
          </If>
          {timestamp}
          {this.props.itemAsset}
          {this.props.platformActions}
          <ItemNetworkIcon network={network} />
          {this.props.networkActions}
          {this.props.sharingActions}
        </div>
      </div>
    );
  }
}

ContentCard.propTypes = {
  item:                PropTypes.instanceOf(DisplayItem),
  assetUrl:            PropTypes.string,
  assetUgcUrl:         PropTypes.string,
  onExternalLinkClick: PropTypes.func,
  itemAsset:           PropTypes.element,
  moduleOpts:          PropTypes.object,
  templateOpts:        PropTypes.object,
  itemOpts:            PropTypes.object,
  onClick:             PropTypes.func.isRequired,
  tabIndex:            PropTypes.number,
  isOverlay:           PropTypes.bool,
  platformActions:     PropTypes.element,
  networkActions:      PropTypes.element,
  sharingActions:      PropTypes.element,
};

ContentCard.defaultProps = {
  item:                {},
  assetUrl:            undefined,
  assetUgcUrl:         undefined,
  onExternalLinkClick: _.noop,
  moduleOpts:          {},
  templateOpts:        {},
  itemOpts:            {},
  itemAsset:           null,
  tabIndex:            0,
  isOverlay:           false,
  platformActions:     null,
  networkActions:      null,
  sharingActions:      null,
};

export default ContentCard;
